(function($, undefined) {
	'use strict';
	var stripe;
	var utils;
    
    var lang = lang || document.documentElement.lang;
    var tax1Label = lang === "fr" ? "TPS" : "GST";
    var tax2Label = lang === "fr" ? "TVQ" : "QST";

	var updateCartTop = function() {
		if ($('.responsive-detector-sm').css('visibility') === 'hidden') {
			utils.updateItemTop(20, $('.checkout__recap'), $('.checkout__right'), $('.checkout__inner'));
		}
	};

	var updateRecap = function() {
		var data = {
			ajax: true
		};

		if ($('.shipping-fee-country').length > 0 && $('.shipping-fee-country').val().length > 0) {
			data.country = $('.shipping-fee-country').val();
		}
		if ($('.select-state-input.required').length > 0 && $('.select-state-input.required').val().length > 0) {
			data.state = $('.select-state-input.required').val();
		}
        data.shippingMethod = $('.shipping-method-select').val();

		$.ajax({
			url: '/action/shopJsonCart',
			cache: false,
			data: data,
			success: function (response) {
				var ctn = $('.checkout__recap');
                var cartInfo = response[response.length - 1];

				$('.promo-name', ctn).html(cartInfo.promoCode);
				var promoAmt = cartInfo.promoAmount;

				if (promoAmt !== '0.00' && promoAmt !== '0,00') {
					$('.promo-val', ctn).html('-' + formatMoney(promoAmt));
					$('.cart__promo').html('-' + formatMoney(promoAmt));
				} else {
					$('.promo-val', ctn).html('');
					$('.cart__promo').html(formatMoney(0));
				}

				var items = response[0];
				for (var item in Object.keys(items)) {
					var qty = items[item].quantity;
					var price = items[item].price;
					var el = $('.cart-item[data-id=' + items[item].id + ']', ctn);

					el.find('.checkout__recap-qty').html('x'+qty);
					el.find('.cart-item__price-total').html(price.indexOf(',') !== -1 ? price + '$' : '$' + price);
				}

				$('.shipping', ctn).html(formatMoney(cartInfo.shipping));
				$('.tax1-name', ctn).html(cartInfo.tax1Name || tax1Label);
				$('.tax1', ctn).html(formatMoney(cartInfo.TPS));
                if (cartInfo.TVQ) {
                    $('.tax2-name', ctn).html(cartInfo.tax2Name || tax2Label);
                    $('.tax2', ctn).html(formatMoney(cartInfo.TVQ))
                        .closest('.checkout__recap-amount').removeClass('hide');
                } else {
                    $('.tax2-name', ctn).html('');
                    $('.tax2', ctn).html('')
                        .closest('.checkout__recap-amount').addClass('hide');
                }
				$('.total', ctn).html(formatMoney(cartInfo.total));
				$('.cart__total').html(formatMoney(cartInfo.subtotalWithPromo));
				$('.subtotal', ctn).html(formatMoney(cartInfo.subtotal));                
			}
		});
	};
    
    var updatePostalCode = function() {
        $('.shipping-postalcode-text').html(this.value);
    };

	var applyPromoCode = function() {
		var btn = $(this);
		var codeInput = btn.closest('.checkout__promo-ctn').find('.promo-code-input');
		var err = $('.promo-code-invalid');
		var errExpired = $('.promo-code-expired');
		var suc = $('.promo-code-valid');

        suc.slideUp();
        err.slideUp();
        errExpired.slideUp();
        
		if (codeInput.val().length === 0) {
			codeInput.closest('.tmpl-form-input-big').addClass('error');
		} else {
			codeInput.closest('.tmpl-form-input-big').removeClass('error');

			var data = {
				"code": codeInput.val(),
				"ajax": true
			};
			
			$.ajax({
				url: '/action/shopApplyPromo',
				cache: false,
				data: data,
				success: function (response) {
					if (response.indexOf('invalid') !== -1) {
						err.slideDown();
					} else if (response.indexOf('expired') !== -1) {
						errExpired.slideDown();
					} else {
                        suc.slideDown();
						updateRecap();
                        btn.addClass('hide');
                        $('.checkout__promo-cancel-ctn').removeClass('hide');
						$('.checkout__recap-amount.promo').slideDown();
					}
				}
			});
		}
	};

	var removePromoCode = function() {
		var btn = $(this);
		var codeInput = btn.closest('.checkout__promo-ctn').find('.promo-code-input');
		var data = {
			"remove": true,
			"ajax": true
		};
        
		$.ajax({
			url: '/action/shopApplyPromo',
			cache: false,
			data: data,
			success: function (response) {
				if (response.indexOf('success') !== -1) {
                    $('.promo-code-valid').slideUp();
					updateRecap();
                    $('.checkout__promo-submit-btn').removeClass('hide');
                    $('.checkout__promo-cancel-ctn').addClass('hide');
					$('.checkout__recap-amount.promo').slideUp();
					codeInput.val('').closest('.tmpl-form-input-big').removeClass('success error has-value');
				}
			}
		});
	};

	var init = function () {
		utils = Fw.component.models().utils;
		stripe = Fw.component.models().stripeToken;
		
		if ($('#stripe-cc-form').length > 0) {
			stripe.init();
		}
		
		if ($('.checkout__recap').length > 0) {
			updateCartTop();
			$(window).scroll(function() {
				updateCartTop();
			});
			$(window).resize(function() {
				updateCartTop();
			});
		}

		$('.shipping-fee-country, .shipping-method-select, .select-state-input').change(updateRecap);
        $('.shipping-postalcode-input').change(updatePostalCode);
        
		$('.checkout__promo-submit-btn').click(applyPromoCode);
		$('.checkout__promo-cancel-btn').click(removePromoCode);
	};
	
	$(window).ready(init);
	
	var checkout = Fw.component.export('checkout', {
		updateRecap: updateRecap
	});
	
})(jQuery);
